import {
  TrialRunDisplayStatus,
  type TrialRunDisplayStatusValue,
  type TrialRunDisplayRow,
} from "./buildTrialRunRow";

// Float the rows that need attention to the top — most severe first — so the operator
// lands on the work rather than on rows that are already clean or ledgered. Lower rank
// sorts higher.
const ATTENTION_RANK: Record<TrialRunDisplayStatusValue, number> = {
  [TrialRunDisplayStatus.Error]: 0,
  [TrialRunDisplayStatus.Failed]: 1,
  [TrialRunDisplayStatus.Warning]: 2,
  [TrialRunDisplayStatus.Success]: 3,
  [TrialRunDisplayStatus.Ledgered]: 4,
};

// Order every trial-run grid attention-first (errors on top, already-ledgered at the
// bottom). Array.sort is stable, so rows sharing a status hold their original file order
// and only move when their status actually changes (e.g. once an error is fixed it sinks
// below the rows still to fix).
export const orderTrialRunRows = (
  rows: TrialRunDisplayRow[],
): TrialRunDisplayRow[] =>
  [...rows].sort(
    (a, b) => ATTENTION_RANK[a.displayStatus] - ATTENTION_RANK[b.displayStatus],
  );
